import React from 'react';
import { Card } from '../ui/Card';
import { MOCK_SITES } from '../../utils/multiSiteData';
import { AlertTriangle, UserX, Cigarette, Activity, ExternalLink } from 'lucide-react';
import { format } from 'date-fns';
import { cn } from '../../utils/cn';
import { Button } from '../ui/Button';
export function CrossSiteAlertFeed() {
  // Flatten alerts from all sites and sort by timestamp
  const allAlerts = MOCK_SITES.flatMap(site => site.alerts).sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
  const getIcon = (type: string) => {
    switch (type) {
      case 'pedestrian':
        return <UserX className="h-4 w-4" data-id="element-143" />;
      case 'smoking':
        return <Cigarette className="h-4 w-4" data-id="element-144" />;
      case 'congestion':
        return <Activity className="h-4 w-4" data-id="element-145" />;
      default:
        return <AlertTriangle className="h-4 w-4" data-id="element-146" />;
    }
  };
  return <Card className="h-full flex flex-col" noPadding data-id="element-147">
      <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-148">
        <h3 className="font-semibold text-white" data-id="element-149">Live Cross-Site Alerts</h3>
        <span className="text-xs text-gray-500 flex items-center gap-1" data-id="element-150">
          <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" data-id="element-151" />
          Live Feed
        </span>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3 max-h-[400px]" data-id="element-152">
        {allAlerts.length === 0 ? <div className="text-center text-gray-500 py-8" data-id="element-153">
            No active alerts across sites
          </div> : allAlerts.map(alert => <div key={alert.id} className={cn('p-3 rounded-lg border flex gap-3 transition-colors', alert.severity === 'high' ? 'bg-red-500/5 border-red-500/20 hover:bg-red-500/10' : 'bg-gray-800/30 border-gray-700 hover:bg-gray-800/50')} data-id="element-154">
              <div className={cn('h-8 w-8 rounded-full flex items-center justify-center shrink-0', alert.severity === 'high' ? 'bg-red-500/10 text-red-500' : 'bg-amber-500/10 text-amber-500')} data-id="element-155">
                {getIcon(alert.type)}
              </div>
              <div className="flex-1 min-w-0" data-id="element-156">
                <div className="flex justify-between items-start mb-1" data-id="element-157">
                  <span className="text-sm font-medium text-white truncate" data-id="element-158">
                    {alert.siteName}
                  </span>
                  <span className="text-xs text-gray-500 whitespace-nowrap" data-id="element-159">
                    {format(alert.timestamp, 'HH:mm')}
                  </span>
                </div>
                <div className="text-xs text-gray-300 mb-1" data-id="element-160">
                  {alert.details}
                </div>
                <div className="flex justify-between items-center" data-id="element-161">
                  <span className="text-[10px] text-gray-500 uppercase tracking-wider" data-id="element-162">
                    {alert.zone}
                  </span>
                  <Button variant="ghost" size="sm" className="h-6 text-[10px] px-2 text-amber-500 hover:text-amber-400" data-id="element-163">
                    View <ExternalLink className="h-3 w-3 ml-1" data-id="element-164" />
                  </Button>
                </div>
              </div>
            </div>)}
      </div>
    </Card>;
}